import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useSaveFileImportConfig = () => {
  const queryClient = useQueryClient()

  const mutationFn = async (payload: {
    feature_type: string,
    mapping?: object,
    last_successful_import_cache?: string
  }) => {
    const res = await fetch('/api/v2/configs/file-import-configs', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload),
    })

    return res.json()
  }

  const mutation = useMutation({
    mutationFn,
    onSuccess: async () => {
      await queryClient.invalidateQueries(['getQueryConfig'])
    }
  })

  return [
    mutation,
    (payload: {
      feature_type: string,
      mapping?: object,
      last_successful_import_cache?: string
    }) => mutation.mutate(payload)
  ] as const;
}
